import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CustomCookieService {

  private key = environment.cookiesEncryptionKey;

  constructor(private cookieService: CookieService) { }

  public saveData(key: string, value: any, path: string = '/', noEncryption?:boolean) {
    if (typeof value !== 'string') value = JSON.stringify(value)
    this.cookieService.set(key, noEncryption ? value : this.encrypt(value), {path});
  }

  public getData(key: string, noDecryption?:boolean): any {
    let data = this.cookieService.get(key) || null;
    return data ? noDecryption ? data : JSON.parse(this.decrypt(data)) : null;
  }
  public removeData(key: string) {
    this.cookieService.delete(key);
  }

  public clearData() {
    this.cookieService.deleteAll('/');
    this.cookieService.deleteAll('/', '.verizon.com');
  }

  public getAll() {
    return this.cookieService.getAll();
  }

  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.key).toString();
  }

  private decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
  }
}
